module.exports = __webpack_public_path__ + "img/fi.b7a5dc7.svg";